type SearchSliderSettingsType = {
    [key: string]: {
        min: number;
        max: number;
        isTemperature?: boolean;
        isFromSelectedValueUp?: boolean;
        units?: "days" | "%" | "m/s" | "h";
    };
};

export const SearchSliderSettings: SearchSliderSettingsType = {
    tmin: {
        min: -6,
        max: 30,
        isTemperature: true
    },
    tmax: {
        min: 0,
        max: 36,
        isTemperature: true
    },
    sst: {
        min: 16,
        max: 32,
        isTemperature: true
    },
    wet: {
        min: 2,
        max: 20,
        units: "days"
    },
    rhm: {
        min: 60,
        max: 90,
        units: "%"
    },
    ws: {
        min: 1,
        max: 5,
        units: "m/s"
    },
    dayhrs: {
        min: 6,
        max: 14,
        units: "h",
        isFromSelectedValueUp: true
    },
    sunhrs: {
        min: 4,
        max: 12,
        units: "h",
        isFromSelectedValueUp: true
    }
};
